/**
 * created on : 2019.04.08
 * 广电广电文稿-串联单详情页
 */
'use strict';
angular.module('iwoSeriesSheetPreviewModule', [])
    .controller('iwoSeriesSheetPreviewCtrl', ['$scope', 'initeditctrBtnsService', 'trsHttpService', '$q', '$stateParams', '$state', 'localStorageService', 'modalDialog', 'trsPrintService', '$sessionStorage', function($scope, initeditctrBtnsService, trsHttpService, $q, $stateParams, $state, localStorageService, modalDialog, trsPrintService, $sessionStorage) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
                // num: [1, 2, 23]
                iwoplatform: $stateParams.iwoplatform,
                btnRights: {},
                sourceid: '',
                serviceid: {
                    '15': 'mlf_tv',
                    '16': 'mlf_broadcast'
                },
                fusionServiceid: {
                    '15': 'mlf_fusiontv',
                    '16': 'mlf_fusionbroadcast'
                },
            };
            $scope.page = {
                PAGESIZE: 20,
                PAGECOUNT: '',
                ITEMCOUNT: '',
                CURRPAGE: 1,
            };
            $scope.data = {
                userData: [],
                detail: '',
                items: [],
                selectedArray: [],
                printResult: []
            };
            initBtnRights();
        }

        /**
         * [initBtnRights description] 初始化按钮权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            var methodnameArray = ['iwo.personal', 'iwo.received'];
            if ($stateParams.iwoplatform == 2 || $stateParams.iwoplatform == 3) {return;}
            initeditctrBtnsService.initIwoData(methodnameArray[$stateParams.iwoplatform]).then(function(data) {
                data.forEach((item, index) => {
                    $scope.status.btnRights[item.OPERNAME.split('.')[2]] = true;
                });
            });
        }

        function initData() {
            // $scope.headPic = '';
            getAllUsers().then(function() {
                return queryChannelForMetadataid();
            }).then(function() {
                return requestData();
            }).then(function(){
                getSeriesSheetList();
            });
        }

        /**
         * [queryChannelForMetadataid 查询串联单所属渠道]
         * @return {[type]} [description]
         */
        function queryChannelForMetadataid() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryDocMediaType',
                ObjectId: $stateParams.iwometadataid
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.sourceid = data.MSG;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getAllUsers description] 获取全部系统用户
         * @return {[type]} [description]
         */
        function getAllUsers() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'queryUsersByName',
                IsSearchAll: true,
                Name: ''
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.userData = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [requestData 获取详情]
         * @return {[type]} [description]
         */
        function requestData() {
            var defer = $q.defer();
            var params = {
                serviceid: $scope.status.fusionServiceid[$scope.status.sourceid],
                methodname: 'getVirtualChuanLianDoc',
                SourceDocId: $stateParams.iwometadataid
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.detail = data;
                document.title = data.TITLE;
                // debugger
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getSeriesSheetList 获取串联单列表]
         * @return {[type]} [description]
         */
        function getSeriesSheetList() {
            var params = {
                serviceid: $scope.status.serviceid[$scope.status.sourceid],
                methodname: 'queryQuoteDocListsToJSON',
                SeriesDocId: $scope.data.detail.METADATAID
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (angular.isArray(data)) {
                    $scope.data.items = data;
                } else {
                    $scope.data.items = data.DATA;
                }
            });
        }

        /**
         * [selectAll 全选]
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.items.length != $scope.data.selectedArray.length && $scope.data.items.length > 0) {
                $scope.data.selectedArray = [];
                for (var i = 0; i < $scope.data.items.length; i++) {
                    $scope.data.selectedArray.push($scope.data.items[i]);
                }
            } else {
                $scope.data.selectedArray = [];
            }
        };

        /**
         * [singleSelect 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(item) {
            var n = $scope.data.selectedArray.indexOf(item);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
        };

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function(direction) { // 88
            var pageTurningData;
            pageTurningData = JSON.parse(localStorageService.get('fusionPreview'));
            var metadataid = $stateParams.iwometadataid;
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (pageTurningData[i].METADATAID === metadataid ||
                    pageTurningData[i].DOCID === metadataid ||
                    pageTurningData[i].MLFID === metadataid) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            if (toPageData.DOCTYPEID == '9' || toPageData.DOCTYPE == '9') {
                broadcastingAndTVGostate(toPageData.DOCTYPEID, toPageData.METADATAID || toPageData.DOCID, toPageData.CHNLDOCID, 'iwomanuscriptpreview');
            } else if (toPageData.DOCTYPEID == '11' || toPageData.DOCTYPE == '11') {
                broadcastingAndTVGostate(toPageData.DOCTYPEID, toPageData.METADATAID || toPageData.DOCID, toPageData.CHNLDOCID, 'iwoseriessheetpreview');
            } else {
                if ($stateParams.iwomodalname === 'iwo.collect') {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.MLFID, toPageData.CHNLDOCID, toPageData.MLFTYPE, toPageData.DOCCOLLECTRELID);
                } else if ($stateParams.iwomodalname === 'iwo.waste') {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.DOCID, toPageData.CHNLDOCID);
                } else {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.METADATAID, toPageData.CHNLDOCID);
                }
            }
        };

        /**
         * [broadcastingAndTVGostate 广电广电文稿预览页跳转]
         * @param  {[type]} doctype       [description]
         * @param  {[type]} iwometadataid [description]
         * @param  {[type]} iwochnldocid  [description]
         * @param  {[type]} mlftype       [description]
         * @param  {[type]} collectid     [description]
         * @param  {[type]} channel       [description]
         * @return {[type]}               [description]
         */
        function broadcastingAndTVGostate(doctype, iwometadataid, iwochnldocid, channel) {
            var url = channel,
                routerParams = {
                    iwotype: doctype,
                    iwomodalname: $stateParams.iwomodalname,
                    wzplatform: 0,
                    wztypeid: doctype,
                    appplatform: 0,
                    newspapertype: 2,
                    iwometadataid: iwometadataid,
                    iwochnldocid: iwochnldocid,
                    iwoplatform: $stateParams.iwoplatform,
                    // mlftype: mlftype, //是否来自资源中心
                    // iwodoccollectrelid: collectid,
                };
            routerParams.appdoctype = doctype;
            $state.go(url, routerParams, {
                reload: true
            }); // new
        }

        /**
         * [fusionGostate description] 融合采编预览页跳转
         * @param  {[type]} doctype       [description]
         * @param  {[type]} iwometadataid [description]
         * @param  {[type]} iwochnldocid  [description]
         * @return {[type]}               [description]
         */
        function fusionGostate(doctype, iwometadataid, iwochnldocid, mlftype, collectid) {
            mlftype = !mlftype ? '' : mlftype;
            collectid = !collectid ? '' : collectid;
            var url = 'fusionpreview',
                routerParams = {
                    iwotype: doctype,
                    iwomodalname: $stateParams.iwomodalname ? $stateParams.iwomodalname : 'iwo.personal',
                    wzplatform: 0,
                    wztypeid: doctype,
                    appplatform: 0,
                    newspapertype: 2,
                    iwometadataid: iwometadataid,
                    iwochnldocid: iwochnldocid,
                    mlftype: mlftype, // 是否来自资源中心
                    iwodoccollectrelid: collectid,
                    iwoplatform: $stateParams.iwoplatform
                };
            routerParams.appdoctype = doctype;
            if (mlftype == 0 || !mlftype) { // iwo
                getBindingMediaIds(iwometadataid).then(function(bingdingData) {
                    angular.forEach(bingdingData, function(value, key) {
                        if (value.MEDIATYPE == '1') {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                            routerParams.appchnldocid = value.CHNLDOCID;
                            routerParams.appmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '2') {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                            routerParams.wzchnldocid = value.CHNLDOCID;
                            routerParams.wzmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '3') {
                            routerParams.paperid = value.CHANNELID; // 预览页与编辑页参数不同
                            routerParams.bzmetadata = value.VIRTUALDOCID; // 预览页与编辑页参数不同
                        }
                    });
                    $state.go(url, routerParams, {
                        reload: true
                    }); // new
                });
            } else {
                $state.go(url, routerParams, {
                    reload: true
                }); // new
            }
        }

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [iwometadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(iwometadataid) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: iwometadataid,
                mediaTypes: ''
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [edit 编辑]
         * @return {[type]} [description]
         */
        $scope.edit = function() {
            var routerParams = {
                iwoplatform: 0,
                iwometadataid: $stateParams.iwometadataid,
                iwochnldocid: $stateParams.iwochnldocid,
            };
            $state.go('iwoplannedorderedit', routerParams);
        };

        /**
         * [highestMedia description：头部- 退出登录]
         */
        $scope.logout = function() {
            // localStorageService.remove('currLoginUser'); // session改变
            $sessionStorage.remove('currLoginUser');
            // localStorageService.remove('mlfCachedUser'); // session改变
            $sessionStorage.remove('mlfCachedUser');
            $('#unreadPrompt_js').hide(); // 关闭传稿提示框
            $.ajax({
                url: '/wcm/logout.jsp',
                method: 'get',
                async: false,
                success: function() {},
                error: function() {}
            });
            $state.go('front.editctr.iWo.personalManuscript', {}, { reload: true });
        };

        /**
         * [printBtn 打印]
         * @return {[type]} [description]
         */
        $scope.printBtn = function() {
            $scope.status.isESSearch = false;
            // if (checkDraftType($scope.status.draftType.subject)) {
            //     modalDialog.alertType("所选稿件中有专题稿，无法打印", '', "error", false);
            //     return;
            // }
            // angular.forEach($scope.data.selectedArray, function(value, key) {
            // requestPrintVersion(value).then(function(data) {
            requestPrintData();
            // });
            // });
        };

        // /**
        //  * [requestPrintVersion 打印流程请求]
        //  * @param  {[type]} item [description]
        //  * @return {[type]}      [description]
        //  */
        // function requestPrintVersion(item) {
        //     var defer = $q.defer();
        //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), {
        //         serviceid: "mlf_metadatalog",
        //         methodname: "query",
        //         MetaDataId: item.METADATAID
        //     }, 'get').then(function(data) {
        //         defer.resolve(data.DATA);
        //     });
        //     return defer.promise;
        // }

        /**
         * [requestPrintData 打印请求详情]
         * @param  {[type]} item    [description]
         * @param  {[type]} version [description]
         * @return {[type]}         [description]
         */
        function requestPrintData() {
            var params = {
                'serviceid': $scope.status.fusionServiceid[$scope.status.sourceid],
                'methodname': 'getVirtualChuanLianDoc',
                'SourceDocId': $stateParams.iwometadataid
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var result = $scope.data.detail;
                result.ITEMS = $scope.data.items;
                // data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                // if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                trsPrintService.trsTvPrintDocument($scope.data.printResult);
                $scope.data.printResult = [];
                // }
            });
        }
    }]);
